import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/helikoptervlucht-logo.png")